var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockDate = function SvgLockDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.2333C30.9025 18.25 29.2938 17 27.3438 17H26.125V13.3333C26.125 8.73833 22.4801 5 18 5C13.5199 5 9.875 8.73833 9.875 13.3333V17H8.65625C6.64125 17 5 18.6833 5 20.75V35.25C5 37.3167 6.64125 39 8.65625 39H21C20 37 19.625 35.6167 19.625 34.1667C19.625 27.2 24.5325 21.4 31 20.2333ZM13.125 17V13.3333C13.125 10.5767 15.3123 8.33333 18 8.33333C20.6877 8.33333 22.875 10.5767 22.875 13.3333V17H13.125Z",
    fill: "#9EA7B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 23C27.4862 23 23 27.4862 23 33C23 38.5138 27.4862 43 33 43C38.5138 43 43 38.5138 43 33C43 27.4862 38.5138 23 33 23ZM36.3954 36.3954C36.0954 36.6954 35.7015 36.8462 35.3077 36.8462C34.9138 36.8462 34.52 36.6954 34.22 36.3954L31.9123 34.0877C31.6231 33.8 31.4615 33.4077 31.4615 33V29.1538C31.4615 28.3046 32.1508 27.6154 33 27.6154C33.8492 27.6154 34.5385 28.3046 34.5385 29.1538V32.3631L36.3954 34.22C36.9969 34.8215 36.9969 35.7938 36.3954 36.3954Z",
    fill: "#9EA7B3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lockDate.51dd4a60.svg";
export { ForwardRef as ReactComponent };